<template>
    <div class="d-flex align-center">
      <div class="flex-fill">
        <v-text-field
          id="messageInput"
          type="text"
          placeholder="Enviar un mensaje"
          dense
          color="white"
          :hide-details="!error"
          v-model="message"
          v-on:keyup.enter="send()"
          focus
          :error="error"
          :error-messages="errorMessage"
          :disabled="disabled"
          class="message-field"
          :style="`border: 1px solid ${error ? 'red' : 'white'};`"
        ></v-text-field>
      </div>
      <div class="pl-1">
        <v-btn
          icon
          color="white"
          @click="send()"
          :disabled="!message"
          :style="{ opacity: `${!message ? '.4' : '1'}` }"
        >
          <Icon
            :width="24"
            color="white"
            :icon="'send'"
          />
        </v-btn>
      </div>
    </div>

</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    disabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    forbiddenWords() {
      return this.$store.state.rooms.item.data?.forbiddenWords
    }
  }
})
export default class TextField extends Vue {
  data () {
    return {
      message: '',
      error: false,
      errorMessage: null
    }
  }

  send () {
    if (!this.message) {
      return false
    }
    const match = this.validateForbiddenWords(this.message)

    if (match > -1) {
      this.error = true
      this.errorMessage = `Palabra prohibida '${this.forbiddenWords[match]}'`
      return false
    } else {
      this.error = false
      this.errorMessage = null
    }

    this.$emit('sendMessage', this.message)
    this.message = ''
  }

  validateForbiddenWords (value) {
    if (!(this.forbiddenWords === null || this.forbiddenWords === undefined || this.forbiddenWords.length === 0)) {
      value = value.toLowerCase()

      for (let i = 0; i < this.forbiddenWords.length; i++) {
        const regex = new RegExp('\\b' + this.forbiddenWords[i] + '\\b')
        if (regex.test(value)) {
          return i
        }
      }
    }

    return -1
  }
}
</script>

<style>
  .message-field{
    font-size: 14px;
    /* border: 1px solid white; */
    border-radius: 20px;
    padding: 5px 15px;
    margin-left: 8px;
    margin-top: 0;
  }
  #messageInput{
    color: #fff;
  }
  #messageInput::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: rgb(201, 201, 201);
  opacity: 1; /* Firefox */
}
</style>
